export class Role {
  description?: string;
  id?: string;
  name?: string;
  status?: boolean;
  type?: string;
  permissionGroups?: PermissionGroup[];
}

export class InstitutionOwner {
  cnpj?: string;
  fantasyName?: string;
  id?: string;
  legalName?: string;
  type?: string;
  permissionGroups?: PermissionGroup[];
  users?: User[];
}

export class PermissionGroup {
  description?: string;
  id?: string;
  name?: string;
  type?: string;
  institution?: InstitutionOwner;
  roles?: Role[];
  users?: User[];
}

export class User {
  ddi?: string;
  birthDate?: Date;
  cellNumber?: string;
  cpf?: string;
  documentNumber?: string;
  id?: string;
  internationalPrefix?: string;
  language?: string;
  nationality?: string;
  status?: string;
  login?: string;
  name?: string;
  passport?: string;
  rg?: string;
  type?: string;
  institution?: InstitutionOwner;
  permissionGroups?: PermissionGroup[];
  clients?: any;
  fone?: string;
}

export class UserPost {
  cpf: string;
  language: string;
  login: string;
  name: string;
  nationality: string;
  passport: string;
  status: string;
  profileId: string;
  investmentGroups: { id: string; }[];
  permissionGroups: { id: string; }[];
  reason: any;
  userSso:any;
}
